<script setup lang="ts">
import { Check } from 'lucide-vue-next';

defineProps({
  progress: { type: Number, required: true },
});
</script>

<template>
  <div
    class="absolute right-0 h-4 w-4 rounded-full overflow-hidden"
    aria-hidden>
    <div
      v-if="progress === 100"
      class="bg-primary-700 flex items-center h-full w-full justify-center">
      <Check class="w-2 stroke-4 stroke-white" />
    </div>
    <div
      v-else-if="progress !== 0"
      class="flex items-end bg-primary-700 h-full w-full"></div>
    <div v-else class="bg-secondary-400 h-full w-full"></div>
  </div>
</template>
